module.exports = __webpack_public_path__ + "img/Subtract.77e170f6.svg";